import { defineMessages } from 'react-intl';
export const messages = defineMessages({
  dataKey: {
    defaultMessage: 'Data Key',
    id: `app.containers.WorkflowEditor.components.Rules.Action.components.DataKeySelect.dataKey`,
  },
});
export default messages;
